"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  currency: function currency(value, code) {
    var client = this.context.get(['client']);
    var details = (client == null ? void 0 : client.details) || {};
    return formatCurrency(details, value, {
      code: code
    });
  },
  currency_round: function currency_round(value, code) {
    var client = this.context.get(['client']);
    var details = (client == null ? void 0 : client.details) || {};
    return formatCurrency(details, value, {
      code: code,
      decimals: 0
    });
  }
};
function formatCurrency(clientDetails, value, params) {
  if (params === void 0) {
    params = {};
  }
  var locale = params.locale || String(clientDetails.locale || '').replace('_', '-') || 'en-US';
  var code = params.code || clientDetails.currency || 'USD';
  var config = (clientDetails.currencies || []).find(function (curr) {
    return curr && curr.code === code;
  });
  var decimals = params.decimals !== undefined ? params.decimals : config && config.decimals || undefined;
  var formatter = getFormatter({
    code: code,
    locale: locale,
    decimals: decimals
  });
  if (typeof value === 'number') {
    return formatter.format(value);
  }

  // Otherwise return the currency symbol only, falling back to '$'
  var parts = formatter.formatToParts && formatter.formatToParts(0);
  if (parts && parts[0] && parts[0].value) {
    return parts[0].value;
  }
  return '$';
}
var FORMATTERS = {};
function getFormatter(_ref) {
  var code = _ref.code,
    locale = _ref.locale,
    decimals = _ref.decimals;
  var key = code + "__" + locale + "__" + decimals;
  if (FORMATTERS[key]) {
    return FORMATTERS[key];
  }
  try {
    return FORMATTERS[key] = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: code,
      currencyDisplay: 'symbol',
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  } catch (err) {
    if (err instanceof RangeError) {
      return getFormatter({
        code: code,
        locale: 'en-US',
        decimals: decimals
      });
    }
    throw err;
  }
}